import React from "react";
import { AccountRegisterScreenContainer } from "../../../containers";

export const AccountRegisterSreen = () => {
  return <AccountRegisterScreenContainer />;
};
